import css from 'styled-jsx/css';

export default css`.search-input-container{
  width: 784px;
  .search-input-box {
    width: 100%;
    height: 52px;
    position: relative;
    .search-input-inner-active {
      border: 2px solid #FF6400;
    }
  }
  .search-input-inner {
    background: #fff;
    position: absolute;
    z-index: 10;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
    box-shadow: 0px 2px 20px 0px rgba(202, 208, 217, 0.4);
    border-radius: 26px;
    overflow: hidden;
    border: 2px solid transparent;

    &:hover{
      border: 2px solid #FF6400;
    }

    .search-input {
      padding: 0 90px 0 14px;
      line-height: 48px;
      box-sizing: border-box;
      input {
        width: 100%;
        border: none;
        outline: none;
        background: transparent;
        font-size: 14px;
        height: 22px;
        line-height: 22px;

        &::placeholder{
          color: #999;
        }
      }
      .search-btn {
        cursor: pointer;
        background: #FF6400;
        border-radius: 20px;
        width: 80px;
        height: 40px;
        position: absolute;
        top: 4px;
        right: 6px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .suggest-list-box {
      position: relative;
      z-index: 2;
      box-sizing: border-box;
      background: #fff;
    }
  }
}`